/*=========================================================================================
  File Name: moduleplannerActions.js
  Description: planner Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js';
import constants from '@/constants.js';

export default {
  async addEvent ({ commit }, event) {
    try {
      const plannerEvent = await axios.post(`${constants.apiHost}/planner`, event);
      commit('ADD_EVENT', Object.assign(event, {id: plannerEvent.data._id}));
      return plannerEvent;
    } catch (err) {
      throw err;
    }
  },
  async fetchEvents ({ commit }, { userId, organizationId }) {
    try {
      const plannerEvents = await axios.get(`${constants.apiHost}/planner`, { params: { userId, organizationId } });
      if(plannerEvents.data && plannerEvents.data.data) {
        plannerEvents.data.data.forEach((event, index) => {
          plannerEvents.data.data[index].startDate = new Date(event.startDate);
          plannerEvents.data.data[index].endDate = new Date(event.endDate);
        });
      }
      commit('SET_EVENTS', plannerEvents.data.data);
      return plannerEvents.data;
    } catch (err) {
      throw err;
    }
  },
  fetchEventLabels ({ commit }) {
    return new Promise((resolve, reject) => {
      // axios.get('/api/apps/planner/labels')
      //   .then((response) => {
      //     commit('SET_LABELS', response.data)
      //     resolve(response)
      //   })
      //   .catch((error) => { reject(error) })
    })
  },
  async editEvent ({ commit }, event) {
    // return new Promise((resolve, reject) => {
    //   axios.post(`/api/apps/planner/event/${event.id}`, {event})
    //     .then((response) => {

    //       // Convert Date String to Date Object
    //       const event = response.data
    //       event.startDate = new Date(event.startDate)
    //       event.endDate = new Date(event.endDate)

    //       commit('UPDATE_EVENT', event)
    //       resolve(response)
    //     })
    //     .catch((error) => { reject(error) })
    // })
    try {
      const plannerEvent = await axios.patch(`${constants.apiHost}/planner/${event._id}`, event);
      plannerEvent.data.startDate = new Date(plannerEvent.data.startDate);
      plannerEvent.data.endDate = new Date(plannerEvent.data.endDate);

      console.log(plannerEvent.data);

      commit('UPDATE_EVENT', plannerEvent.data);
      return plannerEvent;
    } catch (err) {
      throw err;
    }
  },
  async removeEvent ({ commit }, eventId) {
    // return new Promise((resolve, reject) => {
    //   axios.delete(`/api/apps/planner/event/${eventId}`)
    //     .then((response) => {
    //       commit('REMOVE_EVENT', response.data)
    //       resolve(response)
    //     })
    //     .catch((error) => { reject(error) })
    // })
    try {
      const plannerEvent = await axios.delete(`${constants.apiHost}/planner/${eventId}`);
      console.log(plannerEvent);
      commit('REMOVE_EVENT', eventId);
      return plannerEvent.data;
    } catch (err) {
      throw err;
    }
  },
  eventDragged ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/apps/planner/event/dragged/${payload.event.id}`, {payload})
        .then((response) => {

          // Convert Date String to Date Object
          const event = response.data
          event.startDate = new Date(event.startDate)
          event.endDate = new Date(event.endDate)

          commit('UPDATE_EVENT', event)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
